const initialValue = false;

const isLoadingSideContent = (state = initialValue, action) => {
  switch (action.type) {
    case "CHANGE_ISLOADING_SIDE_CONTENT":
      return action.isLoading;
    default:
      return state;
  }
};

export default isLoadingSideContent;
